import { makeAutoObservable, observable } from 'mobx';
import { IUserStore } from './types';
import * as ViewModel from '@/core/presenter/viewModel';
import { COUNTRIES } from '@/mock/Country';

export default class UserStore implements IUserStore {
  @observable private _user: ViewModel.IUser | undefined;
  @observable private _country = COUNTRIES[0].dialCode;
  @observable private _password: string | undefined;
  @observable private _pin: string | undefined;
  @observable private _phone: string | undefined;
  @observable private _name: string | undefined;
  @observable private _prevPin: string | undefined;
  @observable private _myAsset: ViewModel.IMyAsset | undefined;
  @observable private _isLogout: boolean = false;
  constructor() {
    makeAutoObservable(this);
  }

  public get isLogout(): boolean {
    return this._isLogout;
  }

  public get user(): ViewModel.IUser | undefined {
    return this._user;
  }

  public get country(): string | undefined {
    return this._country;
  }

  public get password(): string | undefined {
    return this._password;
  }

  public get pin(): string | undefined {
    return this._pin;
  }

  public get phone(): string | undefined {
    return this._phone;
  }

  public get name(): string | undefined {
    return this._name;
  }

  public get prevPin(): string | undefined {
    return this._prevPin;
  }

  public get myAsset(): ViewModel.IMyAsset | undefined {
    return this._myAsset;
  }

  public setIsLogout(isLogout: boolean): void {
    this._isLogout = isLogout;
  }

  public setUser(user: ViewModel.IUser): void {
    this._user = user;
  }

  public setCountry(country: string): void {
    this._country = country;
  }

  public setPassword(password: string): void {
    this._password = password;
  }

  public setPin(pin: string): void {
    this._pin = pin;
  }

  public setPhone(phone: string): void {
    this._phone = phone;
  }

  public setName(name: string): void {
    this._name = name;
  }

  public setPrevPin(prevPin: string): void {
    this._prevPin = prevPin;
  }

  public setMyAsset(myAsset: ViewModel.IMyAsset): void {
    this._myAsset = myAsset;
  }

  public clearUserData(): void {
    this._user = undefined;
    this._password = undefined;
    this._pin = undefined;
    this._phone = undefined;
    this._name = undefined;
    this._prevPin = undefined;
    this._myAsset = undefined;
  }
}
